export default {
  state:{
    show:true
  },
  mutations:{
    sideBarHide(state){
      state.show = false;
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/sidebar.js